/**
 * Whether open-ended sentiment UI/CSV should include this question.
 * Missing analyze_sentiment → true (legacy questions keep current behavior).
 * @param {{ question_type?: string, analyze_sentiment?: boolean } | null | undefined} question
 * @returns {boolean}
 */
export function isAnalyzeSentimentEnabled(question) {
  if (!question || (question.question_type || "") !== "open_ended") return false;
  return question.analyze_sentiment !== false;
}
